import { useCartState } from "./useCartState";
import { useCartActions } from "./../../../home/hooks/orderSummary/useCartActions";
import { useCartCalculations } from "./../../../home/hooks/orderSummary/useCartCalculations";
import { useEffect } from "react";

export const useCartManagement = () => {
  const { selectedProductslist, setSelectedProductslist, valueMap, setValueMap, condition, setCondition, deliveryFee, setDeliveryFee } = useCartState();

  const { totalQuantity, totalAmount, dis_value, grandTotal } = useCartCalculations(selectedProductslist, valueMap, condition, deliveryFee);

  const { addProductToCart, removeProductFromCart, updateQuantity } = useCartActions({
    selectedProductslist,
    setSelectedProductslist,
    setValueMap,
    setCondition,
  });
  useEffect(() => {
    // Cart empty → delivery fee must be zero
    if (totalAmount === 0 && deliveryFee !== 0) {
      setDeliveryFee(0);
      return;
    }

    // Delivery fee should never exceed subtotal
    if (deliveryFee >= totalAmount && totalAmount > 0) {
      setDeliveryFee(0);
    }
  }, [totalAmount, deliveryFee, setDeliveryFee]);

  const resetCart = () => {
    setSelectedProductslist([]);
    setValueMap({});
    setCondition(0);
    setDeliveryFee(0);
  };

  return {
    selectedProductslist,
    valueMap,
    totalQuantity,
    totalAmount,
    condition,
    dis_value,
    grandTotal,
    setCondition,
    deliveryFee,
    setDeliveryFee,
    addProductToCart,
    removeProductFromCart,
    updateQuantity,
    resetCart,
  };
};
